module.exports = function() {
  return new Worker(__webpack_public_path__ + "4a2dd8df047038df24db.worker.js");
};